import {
    GET_ADD_ON_INPUTS_SUCCESS,
  } from "../actions/addOnInputsActions";
  
  const initState = {
    addOnInputs: [],
  };
  
  const addOnInputsReducer = (state = initState, action) => {
    if (action.type === GET_ADD_ON_INPUTS_SUCCESS) {
      return {
        ...state,
        addOnInputs: action.payload,
      };
    }
  
    return state;
  };
  
  export default addOnInputsReducer;
  